import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

function RejectModal({
  createTextArea,
  formData,
  id,
  getBusinessTransactionHistoryList,
  getBusinessInfo,
  rejectBusiness,
  businessId,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    rejectBusiness(id, formData, () => {
      setModal({ isOpen: false });
      getBusinessTransactionHistoryList(businessId);
      getBusinessInfo(businessId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createTextArea({ key: 'remarks', label: 'Remarks:' }, { required: true, rows: 5 })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">
              Cancel
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RejectModal.propTypes = {
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  rejectBusiness: PropTypes.instanceOf(Function).isRequired,
  getBusinessTransactionHistoryList: PropTypes.instanceOf(Function).isRequired,
  getBusinessInfo: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(RejectModal);
